// src/context/DemoModeContext.tsx
import React, { createContext, useContext, useState, useCallback } from 'react';

interface DemoModeContextType {
  isDemo: boolean;
  toggleDemo: () => void;
  enableDemo: () => void;
  disableDemo: () => void;
}

const DemoModeContext = createContext<DemoModeContextType | undefined>(undefined);

export const DemoModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemo, setIsDemo] = useState(false);

  const toggleDemo = useCallback(() => setIsDemo(prev => !prev), []);
  const enableDemo = useCallback(() => setIsDemo(true), []);
  const disableDemo = useCallback(() => setIsDemo(false), []);

  return (
    <DemoModeContext.Provider value={{ isDemo, toggleDemo, enableDemo, disableDemo }}>
      {isDemo && (
        <div className="demo-badge">DEMO MODE</div>
      )}
      {children}
    </DemoModeContext.Provider>
  );
};

export const useDemoMode = () => {
  const context = useContext(DemoModeContext);
  if (!context) throw new Error('useDemoMode must be used within DemoModeProvider');
  return context;
};

export default DemoModeContext;
